import {NgModule} from '@angular/core';

import {ListGroupModule} from './components/list-group/list-group.module';
import {ComboBoxModule} from './components/combo-box/combo-box.module';
import {ComboBoxDropdownModule} from './components/combo-box-dropdown/combo-box-dropdown.module';
import {InputModule} from './components/input/input.module';
import {CountrySelectorModule} from './components/country-selector/country-selector.module';
import {CheckboxModule} from './components/checkbox/checkbox.module';
import {TextSearchHighlightModule} from './pipes/text-search-highlight/text-search-highlight.module';
import {PaginationModule} from './components/pagination/pagination.module';
import {SimplePaginationModule} from './components/simple-pagination/simple-pagination.module';
import {BreadcrumbModule} from './components/breadcrumb/breadcrumb.module';
import {QuantityModule} from './components/quantity-selector/quantity.module';
import {DatePickerModule} from './components/date-picker/date-picker.module';
import {MessageModule} from './components/message/message.module';
import {ModalModule} from './components/modal/modal.module';
import {AccordionModule} from './components/accordion/accordion.module';
import {BaseControlComponent} from './components/base-control.component';
import {RadioGroupModule} from './components/radio-group/radio-group.module';
import {CheckboxGroupModule} from './components/checkbox-group/checkbox-group.module';
import {TextareaModule} from './components/textarea/textarea.module';
import {TooltipModule} from './components/tooltip/tooltip.module';
import {UploadModule} from './components/upload/upload.module';
import {NavModule} from './components/nav/nav.module';
import {SliderModule} from './components/slider/slider.module';

const modules = [
  AccordionModule,
  BreadcrumbModule,
  CheckboxModule,
  ComboBoxDropdownModule,
  ComboBoxModule,
  CountrySelectorModule,
  DatePickerModule,
  InputModule,
  ListGroupModule,
  MessageModule,
  ModalModule,
  NavModule,
  PaginationModule,
  QuantityModule,
  SimplePaginationModule,
  TextSearchHighlightModule,
  RadioGroupModule,
  CheckboxGroupModule,
  TooltipModule,
  TextareaModule,
  UploadModule,
  SliderModule
];

@NgModule({
  declarations: [BaseControlComponent],
  imports: [...modules],
  exports: [...modules]
})
export class NgDesignSystemModule {
}
